import { Link } from "react-router-dom";
import {
  facebook,
  instagram,
  linkedin,
  logoWhite,
  tiktok,
  x,
} from "../../assets/images";

const socialLinks = [
  { href: "https://tiktok.com/@haircareai ", icon: tiktok, alt: "TikTok" },
  {
    href: "https://instagram.com/haircareai/",
    icon: instagram,
    alt: "Instagram",
  },
  { href: "https://x.com/haircare_ai", icon: x, alt: "x" },
  {
    href: "https://linkedin.com/company/haircareai/",
    icon: linkedin,
    alt: "LinkedIn",
  },
  {
    href: "https://web.facebook.com/haircareai",
    icon: facebook,
    alt: "Facebook",
  },
];

const Footer = () => {
  return (
    <div className="lg:h-[300px] h-[150px] w-full flex justify-center items-end pb-3 bg-gray-950">
      <div className="mx-3 lg:mx-20 pt-[60px] flex flex-col space-y-2 justify-center items-center">
        <div>
          <Link to="/">
            <img src={logoWhite} className="h-[55px] md:h-[65px]" alt="Logo" />
          </Link>
        </div>
        <div className="flex flex-row space-x-8 lg:space-x-20">
          {socialLinks.map(({ href, icon, alt }) => (
            <a
              key={alt}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={alt}
            >
              <img src={icon} className="h-[20px] md:h-[20px]" alt={alt} />
            </a>
          ))}
        </div>
        <div className="pt-5">
          <p className="text-center text-[12px] text-white">
            Haircare AI © 2024. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
